/*
  Drives the cursor for the per-bottle hover targets. Everything hangs off the
  layer carrying [data-bottle-hotspots], which sits over the photo and holds
  both the targets and the cursor.

  The pointer is tracked on that layer rather than on the element wrapping the
  image, because a host can stack its own content over its image and take the
  hover first - image-banner does exactly that.

  Pointer devices only - on touch the targets are hidden in CSS and there is
  nothing to drive.
*/
(function () {
  'use strict';

  var FINE_POINTER = '(hover: hover) and (pointer: fine)';
  /* How much of the remaining distance the cursor closes each frame. Lower
     trails further behind the pointer; 1 pins it exactly. */
  var FOLLOW = 0.22;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(layer) {
    if (layer.dataset.bottleHotspotsReady === 'true') return;

    var cursor = layer.querySelector('[data-bottle-cursor]');
    var hotspots = layer.querySelectorAll('[data-bottle-hotspot]');

    if (!cursor || hotspots.length === 0) return;
    if (!window.matchMedia(FINE_POINTER).matches) return;

    layer.dataset.bottleHotspotsReady = 'true';

    var follow = prefersReducedMotion() ? 1 : FOLLOW;
    var pointerX = 0;
    var pointerY = 0;
    var cursorX = 0;
    var cursorY = 0;
    var frame = null;
    var visible = false;

    function render() {
      cursorX += (pointerX - cursorX) * follow;
      cursorY += (pointerY - cursorY) * follow;
      cursor.style.transform = 'translate3d(' + cursorX + 'px, ' + cursorY + 'px, 0)';

      var settled = Math.abs(pointerX - cursorX) < 0.1 && Math.abs(pointerY - cursorY) < 0.1;
      if (visible || !settled) {
        frame = window.requestAnimationFrame(render);
      } else {
        frame = null;
      }
    }

    function start() {
      if (frame === null) frame = window.requestAnimationFrame(render);
    }

    function readPointer(event) {
      var rect = layer.getBoundingClientRect();
      pointerX = event.clientX - rect.left;
      pointerY = event.clientY - rect.top;
    }

    layer.addEventListener('pointerenter', function (event) {
      /* Drop the cursor straight onto the pointer on the way in, otherwise it
         flies across the image from wherever it was last left. */
      readPointer(event);
      cursorX = pointerX;
      cursorY = pointerY;
      visible = true;
      layer.classList.add('is-cursor-active', 'is-cursor-visible');
      start();
    });

    layer.addEventListener('pointermove', function (event) {
      readPointer(event);
      start();
    });

    layer.addEventListener('pointerleave', function () {
      visible = false;
      layer.classList.remove('is-cursor-active', 'is-cursor-visible', 'is-cursor-open');
      cursor.removeAttribute('data-bottle-active');
    });

    Array.prototype.forEach.call(hotspots, function (hotspot) {
      hotspot.addEventListener('pointerenter', function () {
        cursor.setAttribute('data-bottle-active', hotspot.dataset.bottleHotspot);
        layer.classList.add('is-cursor-open');
      });

      hotspot.addEventListener('pointerleave', function () {
        layer.classList.remove('is-cursor-open');
      });
    });
  }

  function initAll(scope) {
    var layers = (scope || document).querySelectorAll('[data-bottle-hotspots]');
    Array.prototype.forEach.call(layers, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* The theme editor rebuilds a section in place; re-bind the new markup. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
